export const home = () => {};

const getMonthDisplay = () =>
  TT.lang != 'en' ? new Date().getMonth() + 1 : new Date().toLocaleDateString('en', { month: 'long' });

const krCuration = (current_month) => [
  {
    image_src:
      '//s3.marpple.co/files/u_1504988/2023/10/original/556723c4d90da4a25f4b4f546dfb0f3ccd72a7e89.png',
    /* content: TT('keyword::kwd_new', {
      month: current_month,
    }),*/
    content: TT('keyword::kwd_new'),
    icon: '📆',
    url: '/new-products',
  },
  {
    image_src:
      '//s3.marpple.co/files/u_2798351/2025/3/original/0cbe3253b3d0a1bdd1677001ba6a58a7df2a57e12.png',
    content: TT('keyword::kwd_best'),
    icon: '🔮',
    url: '/best-products',
  },
  {
    image_src:
      '//s3.marpple.co/files/u_2798351/2025/5/original/d2a6a59a444036282bc5dfbdc680634b8b4615701.png',
    content: TT('keyword::kwd_1_14'),
    icon: '🎉',
    url: '/customstore',
    target: '_blank',
  },
  {
    image_src:
      '//s3.marpple.co/files/u_2798351/2025/5/original/c038071a6034f76545da6217f80df33bf0e84ecf1.png',
    content: TT('keyword::kwd_1_7'),
    icon: '🎁',
    url: '/kit',
  },
  {
    image_src:
      '//s3.marpple.co/files/u_2798351/2024/11/original/ff27092381003c5a5fdff80a105564fbdee986d31.png',
    content: TT('keyword::kwd_1_11'),
    icon: '📱',
    url: '/product/list/12',
  },
  {
    image_src:
      '//s3.marpple.co/files/u_2798351/2024/11/original/6d1421c7b37013c44edbd2a3e203ef861e7ae4616.png',
    content: TT('keyword::kwd_1_10'),
    icon: '🧳',
    url: TT('url::url_2'),
  },
  {
    image_src:
      '//s3.marpple.co/files/u_2798351/2024/11/original/ee2ef577f85e9653f070646d80c43cd18d5ba9398.png',
    content: TT('keyword::kwd_1_4'),
    icon: '💌',
    url: '/product/list/188?cate_item_id=&sort=pick&f_34%5B%5D=765',
  },
  {
    image_src:
      '//s3.marpple.co/files/u_2798351/2025/5/original/841edac0aef2dfabae27d00a91d7341cc91c05951.png',
    content: TT('keyword::kwd_1_12'),
    icon: '🗒️',
    url: '/search/products?q=다꾸굿즈',
  },
  {
    image_src:
      '//s3.marpple.co/files/u_2798351/2024/12/original/391275b67fdfdc2cde2828f586ba1e4a01d97b0e1.png',
    content: TT('keyword::kwd_1_1'),
    icon: '🖥️',
    url: '/search/all?q=데스크',
  },
];

const otherCuration = (current_month) => [
  {
    image_src:
      '//s3.marpple.co/files/u_1504988/2023/10/original/556723c4d90da4a25f4b4f546dfb0f3ccd72a7e89.png',
    content: TT('keyword::kwd_new', {
      month: current_month,
    }),
    icon: '📆',
    url: '/new-products',
  },
  {
    image_src:
      '//s3.marpple.co/files/u_1504988/2023/10/original/295d085bf13f82096f723bf623099ef3c9e705e71.png',
    content: TT('keyword::kwd_best'),
    icon: '🔮',
    url: '/best-products',
  },
  {
    image_src:
      '//s3.marpple.co/files/u_2798351/2024/5/original/9a6567fefc6a0f994044a874a7963538035c9dac1.png',
    content: TT('keyword::kwd_1_1'),
    icon: '🏫',
    url: TT('url::url_1'),
  },
  {
    image_src:
      '//s3.marpple.co/files/u_2798351/2024/5/original/e99a08ca0101b74ac6d96bd2d6e53f00330a7ac41.png',
    content: TT('keyword::kwd_1_2'),
    icon: '👆🏽',
    url: '/product/list/9',
  },
  {
    image_src:
      '//s3.marpple.co/files/u_1504988/2023/10/original/3989a94b36429b75be3fbce5540f2e6d7a66a9654.png',
    content: TT('keyword::kwd_1_3'),
    icon: '💼',
    url: '/kit',
  },
  {
    image_src:
      '//s3.marpple.co/files/u_2798351/2024/2/original/0d584c267cefbfcc8818f81deb0a9d895fd619d11.png',
    content: TT('keyword::kwd_1_4'),
    icon: '😎',
    url: '/product/list/188?cate_item_id=&sort=pick&f_34%5B%5D=765',
  },
  {
    image_src:
      '//s3.marpple.co/files/u_2798351/2024/5/original/7c00c979e67227ccbc5fc7f9d2d5c7bbdddf80682.png',
    content: TT('keyword::kwd_1_5'),
    icon: '🌂',
    url: '/biz?biz_filters=72&offset=0&limit=20&sort=pick',
  },
  {
    image_src:
      '//s3.marpple.co/files/u_1504988/2023/10/original/48f484723876d8f6c6816c7a172494f1508e41526.png',
    content: TT('keyword::kwd_1_6'),
    icon: '🌿',
    url: TT('url::url_5'),
  },
  {
    image_src:
      '//s3.marpple.co/files/u_1504988/2023/10/original/a2c503c49463b899ea876374596d460b87ba4bda3.png',
    content: TT('keyword::kwd_1_7'),
    icon: '🫧',
    url: '/product/list/188?cate_item_id=332',
  },
];

export const curationKeywords = () => {
  const current_month = getMonthDisplay();
  return TT.lang === 'kr' ? krCuration(current_month) : otherCuration(current_month);
};
